import Steps from 'antd/lib/steps'
import './index.less'

export default Steps



// WEBPACK FOOTER //
// ./src/elements/steps/index.js